import React, { memo, useState, useCallback } from "react";
import { useTranslate } from "helpers";
import { EposlovanjeSettingsCardProps } from "./types";
import { EposlovanjeSettings } from "../../../../types";
import { TextField } from "ui/components/TextField/TextField";
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import EposlovanjeEditCard from "./components/EposlovanjeEditCard/EposlovanjeEditCard";

const EposlovanjeSettingsCard: React.FC<EposlovanjeSettingsCardProps> = ({
  settings,
  onSave,
  isLoading = false,
}) => {
  const { t } = useTranslate();
  const [formValues, setFormValues] = useState<EposlovanjeSettings>(settings);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleEditSuccess = useCallback(() => {
    onSave(formValues);
    setShowEditModal(false);
  }, [formValues, onSave]);

  return (
    <>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.integration.eposlovanje.settings.title")}
            </p>
            <p className="text-sm">
              {t("admin.integration.eposlovanje.settings.description")}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1  px-3 my-3">
          <div className="flex flex-col">
            <div className="mb-3">
              <TextField
                type="text"
                name="apiKey"
                label="API ključ"
                value={formValues.apiKey}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div className="mb-3">
              <TextField
                type="text"
                name="companyVatId"
                label="OIB tvrtke"
                value={formValues.companyVatId}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div className="mb-3">
              <TextField
                type="text"
                name="businessUnit"
                label="Poslovni prostor"
                value={formValues.businessUnit}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div>
              <TextField
                type="text"
                name="software"
                label="Software"
                value={formValues.software}
                disabled
                cssClassName="bg-white"
              />
            </div>
          </div>
          <div>
            <Button
              variant="outlined"
              children={t("admin.edit")}
              onClick={handleEditClick}
              startIcon="/media/icons/plus.svg"
            />
          </div>
        </div>
      </div>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <ModalHeader
          title={t("admin.integration.eposlovanje.edit.title")}
          icon="/media/images/add-icon.svg"
          onHide={() => setShowEditModal(false)}
        />
        <ModalBody>
          {showEditModal && (
            <EposlovanjeEditCard
              settings={formValues}
              setSettings={setFormValues}
              onSuccess={handleEditSuccess}
              onClose={() => setShowEditModal(false)}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default memo(EposlovanjeSettingsCard);
